import { render, staticRenderFns } from "./noticeIndex.vue?vue&type=template&id=185c5e6a&scoped=true&"
import script from "./noticeIndex.vue?vue&type=script&lang=js&"
export * from "./noticeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c5e6a",
  null
  
)

export default component.exports